import { handleActions } from 'redux-actions';
import { siteLoaded } from '../actions';

const initialState = {
    siteExists: undefined,
};

export default handleActions(
    {
        [siteLoaded]: (state, action) => ({
            ...state,
            ...action.payload,
        }),
    },
    initialState,
);
